import Vue from 'vue';
import VueRouter from 'vue-router';
import Index from './pages/index';
import TableList from './pages/table-list';
import Summary from './pages/privacy-summary';

Vue.use(VueRouter);

export default new VueRouter({
    mode: "hash",
    routes: [
        {
            path: '/index',
            name: 'index',
            component: Index,
            meta: {
                title: '个人信息收集清单',
            }
        },
        {
            path: '/list',
            name: 'list',
            component: TableList,
            meta: {
                title: '信息列表'
            } 
        },
        {
            path: '/summary',
            name: 'summary',
            component: Summary,
            meta: {
                title: '隐私权保护政策摘要',
            }
        },
        {
            path: '*',
            redirect: {
                path: '/index',
            }
        },
    ],
});
